import React, { useCallback, useContext, useState } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import noop from '../../../../../utils/noop';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import ShareIcon from '@wix/da-ds/pkg/Icons/24x24/Share';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import { BiData } from '@wix/da-bi/pkg/events';
import DesktopShareModal from '../../../../../SharePopup/DesktopSharePopup/DesktopShareModal';
import { getDeviationResourceType } from '../../../../_helpers';
import overlayStyles from '../../../../Helper/OverlayIcons.scss';
const ShareControl = ({ deviation, className, buttonClassName, iconClassName, textClassName, showMobileSharePopup = noop })=>{
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    const [sharePopupVisible, setSharePopupVisible] = useState(false);
    const onClick = useCallback(()=>{
        if (isMobile) {
            showMobileSharePopup();
        } else {
            setSharePopupVisible(true);
        }
    }, [
        showMobileSharePopup,
        setSharePopupVisible,
        isMobile
    ]);
    const onDismiss = useCallback(()=>{
        setSharePopupVisible(false);
    }, [
        setSharePopupVisible
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: className
    }, sharePopupVisible && /*#__PURE__*/ React.createElement(DesktopShareModal, {
        onRequestClose: onDismiss,
        deviation: deviation
    }), /*#__PURE__*/ React.createElement(TextButton, {
        size: "medium",
        variant: "main",
        className: classnames(buttonClassName, overlayStyles['icon-button']),
        onClick: onClick,
        biData: BiData({
            evid: 355,
            typeid: getDeviationResourceType(deviation),
            itemid: deviation.deviationId,
            deviationid: deviation.deviationId
        }),
        "data-hook": BiDataHook.DEVIATION_SHARE_BUTTON,
        "aria-label": t('deviationview.overlay.a11y.share')
    }, /*#__PURE__*/ React.createElement(ShareIcon, {
        size: IconSize.MEDIUM,
        withPadding: false,
        disableDefaultColors: true,
        className: classnames(overlayStyles['icon'], iconClassName)
    }), /*#__PURE__*/ React.createElement("span", {
        className: textClassName
    }, t('actionbar.shareFromFeed'))));
};
ShareControl.displayName = 'ShareControl';
export default ShareControl;
